import { z } from "zod";
import {
  ADDRESS,
  ADDRESS_1,
  ADDRESS_2,
  ALTERNATE_LOGIN_ID,
  BOM_POSITION,
  BOM_START_DATE,
  CITY,
  EMAIL_ID_1,
  EMAIL_ID_2,
  END_DATE,
  FIRST_NAME,
  IS_BOM_USER,
  LANDLINE_NO,
  LAST_NAME,
  MOBILE_NO,
  OCCUPANCY_TYPE,
  PO_BOX,
  START_DATE,
  STATE,
  USER_ID,
  USERNAME,
  ZIPCODE,
} from "./consts";

export const schema = z.object({
  [USER_ID]: z.string().optional(),
  [ALTERNATE_LOGIN_ID]: z.string().min(4, "Please enter Alternate Login ID."),
  [FIRST_NAME]: z.string().min(2, "Please enter First Name."),
  [LAST_NAME]: z.string().min(2, "Please enter Last Name."),
  [MOBILE_NO]: z.string().min(10, "Please enter Mobile Number."),
  [EMAIL_ID_1]: z
    .string()
    .min(1, "Please enter Contact Email.")
    .email("This is not a valid email."),
  [ADDRESS]: z.object({
    [ADDRESS_1]: z.string().min(1, "Please enter Address 1."),
    [ADDRESS_2]: z.string().optional(),
    [ZIPCODE]: z
      .string()
      .min(1, "Please enter Zipcode.")
      .regex(/^[0-9]{5}-[0-9]{4}$/, "Enter ZIP code in XXXXX-XXXX format."),
    [STATE]: z.string().min(1, "Please enter State."),
    [CITY]: z.string().min(1, "Please enter City."),
    [PO_BOX]: z.string().min(1, "Please enter P.O. Box."),
  }),
  [OCCUPANCY_TYPE]: z.string().min(1, "Please enter Occupancy Type."),

  // Optional Fields
  [LANDLINE_NO]: z.string().optional(),
  [EMAIL_ID_2]: z
    .string()
    .email("This is not a valid email.")
    .optional()
    .or(z.literal("")),

  [START_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    }),
  [END_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !val || !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    })
    .optional(),
  [USERNAME]: z.string().min(4, "Please enter User ID."),
  [IS_BOM_USER]: z.boolean().optional(),
  [BOM_POSITION]: z.string().optional(),
  [BOM_START_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !val || !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    })
    .optional(),
});

export type formValues = z.infer<typeof schema>;
